import React from 'react'
import { useTranslation } from 'react-i18next'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ShowMore } from 'pages/Home/components/ShowMore'
import { ITag } from '../molecules/Courses'
import { Tag } from '../../../../ui/LearningPathCard/components/atoms/Tag'
import styles from './atoms.module.scss'

interface IHeader {
  iconColor?: string
  icon?: any
  title: string
  count: number
  href?: string
  viewAll?: boolean
  tag?: ITag
}

export const FolderHeader: React.FC<IHeader> = ({
  iconColor,
  icon,
  title,
  count,
  href,
  viewAll = true,
  tag,
}) => {
  const { t } = useTranslation()

  return (
    <div className={`col-18 ${styles.headerCardWrapper}`}>
      <div className={`${styles.cardBody}`}>
        <div className={`${styles.cardIconWrapper}`}>
          <div
            className={`${styles.iconBackground}`}
            style={{ backgroundColor: iconColor }}
          ></div>
          <FontAwesomeIcon
            icon={icon}
            className={`${styles.cardIcon}`}
            color={iconColor}
          />
        </div>
        <div className={`${styles.cardTitle}`}>{title}</div>
        {tag && (
          <div className={`${styles.cardTag}`}>
            <Tag text={tag.name} icon={tag.icon} />
          </div>
        )}
        <div className={`${styles.courseCounterWrapper}`}>
          <div
            className={`${styles.counterBackground}`}
            style={{ backgroundColor: '#CFE7FD' }}
          ></div>
          <p className={`${styles.cardCounter}`}>{count}</p>
        </div>
      </div>
      <div className={`${styles.headerViewAll}`}>
        {!!href && viewAll && count > 0 && (
          <ShowMore to={href}>
            {t('viewAll.viewAllButton')}
            <FontAwesomeIcon className="ml-2" icon={faArrowRight} />
          </ShowMore>
        )}
      </div>
    </div>
  )
}
